const isDate = (value) => {
  if (new Date(value) !== "Invalid Date" && !isNaN(new Date(value))) {
    return value == new Date(value).toISOString();
  } else {
    return false;
  }
};

export default isDate;
